import { PatientId } from "../../../shared/schema/schema";
import ServicePlanList from "./ServicePlanList";

type Props = {
  patientId: PatientId;
};

export default function PatientCdscImportSection({ patientId }: Props) {
  return <ServicePlanList patientId={patientId} />;
}
